export const EMERGENCY_TAGLINE = 'Call Today - 24/7 Emergency Services';

/** Matches site grid `maxWidth` + gutters (`Container` outer edge). */
export const HEADER_GRID_MAX_WIDTH_PX = 1920;
export const HEADER_GRID_GUTTER_PX = 24;
export const HEADER_CONTAINER_OUTER_MAX_PX = HEADER_GRID_MAX_WIDTH_PX + HEADER_GRID_GUTTER_PX * 2;

export const HEADER_DROPDOWN_MAX_WIDTH = '1313px';

export const HEADER_LOGO_WIDTH = '184px';

export const HEADER_CHROME_PADDING_Y = '11px';

/** Primary nav link row min-height at compact header (`headerTb` / `tb`). */
export const HEADER_COMPACT_MENU_ROW_MIN_HEIGHT = '54px';

export const getColumnWidthAndOffset = (
    columnCount: number,
    columnGapPixels: number,
    subgroupLength: number,
): {
    widthPercent: number,
    offsetPixels: number
} => {
    if (subgroupLength > columnCount) {
        // We're subdividing to fit the space available
        const totalGapSize = columnGapPixels * (subgroupLength - 1); // The column count - 1, because we only care about the spaces
        const individualGapDecrement = totalGapSize / subgroupLength; // The width adjustment per col for even gapping
        const colPcSize = 100 / subgroupLength;
        return {
            widthPercent: colPcSize,
            offsetPixels: individualGapDecrement,
        };
    }

    const totalGapSize = columnGapPixels * (columnCount - 1); // The column count - 1, because we only care about the spaces
    const individualGapDecrement = totalGapSize / columnCount; // The width adjustment per col for even gapping

    const columnsInItem = Math.max(1, subgroupLength);

    const colPcSize = 100 / columnCount;
    const columnWidth = Math.min(columnsInItem * colPcSize, columnCount * colPcSize); // Max it out at the max column count

    const skippedColumnIncr = columnGapPixels / 4; // The unit we need to use to compensate for the gap not existing, when columns > 1

    const offsetPx = individualGapDecrement - (skippedColumnIncr * columnsInItem) + skippedColumnIncr;

    return {
        widthPercent: columnWidth,
        offsetPixels: offsetPx,
    };
};

export const getHeaderContentWidth = (
    maxDropdownSize: number,
    childMenuLength: number,
    maxAvailableColumns: number,
): string => `min(${
    Math.max(
        1,
        Math.min(childMenuLength === (maxAvailableColumns - 1) ? maxAvailableColumns : childMenuLength, maxAvailableColumns),
    ) * (maxDropdownSize / maxAvailableColumns)}px, ${
    Math.max(
        1,
        Math.min(childMenuLength === (maxAvailableColumns - 1) ? maxAvailableColumns : childMenuLength, maxAvailableColumns),
    ) * (98.5 / maxAvailableColumns)}vw)`;
